import {observable, computed, action} from 'mobx';

class EventsStore {
    constructor() {
        this.isPopulated = false;
        this.events = observable([]);
        this.bySlug = observable(new Map());
    }

    @action async populate() {
        let events = (await (await fetch(__bootstrap.config.apiBaseUrl + 'events')).json());
        for (let i = 0; i < events.length; i++) {
            if (this.events.length > i && this.events[i] && this.events[i].slug === events[i].slug && this.events[i].$$detailed) {
                continue
            }

            this.events[i] = events[i];
            this.bySlug.set(events[i].slug, events[i])
        }

        this.events.replace(events);
        this.isPopulated = true;
    }

    @action async fetchBySlug(slug, force) {
        let event = this.bySlug.get(slug);
        if (!force && event && event.$$detailed) {
            return event
        }

        event = (await (await fetch(__bootstrap.config.apiBaseUrl + 'events/' + slug)).json());
        event.$$detailed = true;

        let posts = [];

        if (event.resources !== undefined) {
            event.resources = event.resources.filter((link) => {
                if (link.rel === "post") {
                    posts.push(link);
                    return false;
                }

                return true;
            });

            // Can happen after the filtering, so we unset it entirely to not have to deal with
            // further type checking.
            if (event.resources.length === 0) {
                event.resources = undefined;
            }
        }

        if (posts.length > 0) {
            event.posts = posts;
        }

        let i = this.events.findIndex(v => v.slug === slug);

        if (i !== -1) {
            this.events[i] = event
        } else {
            this.events.push(event)
        }

        this.bySlug.set(event.slug, event);

        return event;
    }
}

const store = new EventsStore();

export default store;


// WEBPACK FOOTER //
// ./src/modules/Events/Store.js